import uuid from '../../../services/uuid';
import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';

export const cloneCourse = (trainingId: string, newName: string, orgId?: string, initiatingUserId?: string) => {
  const id = uuid.generate();
  cacheService.removeAllInPath(`/v1/tasklists?orgId=${orgId}`);
  return submitCommand(
    id,
    { id: id, fromId: trainingId, newName, newOwner: orgId, initiatingUserId },
    'CloneTaskList',
    'TaskListCloned',
    ['TaskListFailedToClone', 'TaskListNameDuplicateError']
  );
};
